import * as actions from '../../actions/profile';

import { initialState } from './initialState';

export { initialState };

export const profileState = (state = initialState, action) => {
    switch (action.type) {
        case actions.APPRAISAL_LOADED:
            return { ...state, appraisals: action.payload, error: false, loading: false, saving: false };
        case actions.PROFILE_LOADED:
            return { ...state, profile: action.payload, error: false, loading: false, saving: false };
        case actions.COMPETENCIES_LOADED:
            return { ...state, competencies: action.payload, error: false, loading: false, saving: false };
        case actions.AVAILABLE_COMPETENCIES_LOADED:
            return { ...state, availableCompetencies: action.payload, error: false, loading: false, saving: false };
        case actions.TEAM_LOADED:
            return {
                ...state,
                team: action.payload,
                error: false,
                loading: false,
                saving: false,
            };
        case actions.ACTIVE_PROFILES_LOADED:
            return { ...state, activeProfiles: action.payload, error: false, loading: false, saving: false };
        case actions.TEAMMATES_LOADED:
            return { ...state, teammates: action.payload, error: false, loading: false, saving: false };
        case actions.TASK_LOADED:
            return { ...state, task: action.payload, error: false, loading: false, saving: false };
        case actions.TASK_PROGRESS_LOADED:
            return { ...state, taskProgress: action.payload, error: false, loading: false, saving: false };
        case actions.TASKS_LOADED:
            return { ...state, taskList: action.payload, error: false, loading: false, saving: false };
        case actions.ONE_2_ONE_NOTES_LOADED:
            return { ...state, one2OneNotes: action.payload, error: false, loading: false, saving: false };
        case actions.DISCUSSION_POINTS_LOADED:
            return { ...state, discussionPoints: action.payload, error: false, loading: false, saving: false };
        case actions.TASK_SUMMARY_LOADED:
            return { ...state, taskSummary: action.payload, error: false, loading: false, saving: false };
        case actions.SAVING:
            return { ...state, saving: action.payload };
        case actions.LOADING:
            return {
                ...state,
                loading: action.payload,
                error: action.payload ? false : state.error,
                forbidden: action.payload ? false : state.forbidden,
            };
        case actions.ERROR:
            return { ...state, error: action.payload, loading: false };
        case actions.FORBIDDEN:
            return { ...state, forbidden: true, error: false, loading: false };
        case actions.CLEAR_PROFILE:
            return initialState;
        default:
            return state;
    }
};
